import { ServizioStruttura, TipoServizioStruttura, OrarioStruttura } from '@hm_app/@core/models/struttura';
import { Component, OnInit, Input } from '@angular/core';
import { Provincia, Comune, Distretto, AziendaSanitaria } from '@hm_app/@core/models/anagrafica_geo';
import * as _ from 'lodash-es';
import { Struttura, TipologiaStruttura } from '@hm_app/@core/models/struttura';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { trimTrailingNulls } from '@angular/compiler/src/render3/view/util';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { StrutturaDetailComponent } from '@hm_app/shared/strutture/struttura-detail/struttura-detail.component';

@Component({
    selector: 'strutture-riferimento',
    templateUrl: './strutture-riferimento.component.html',
    styleUrls: ['./strutture-riferimento.component.scss'],
})
export class StruttureRiferimentoComponent implements OnInit {

   province_toscane = new Array<Provincia>();
   comuni = new Array<Comune>();
   distretti = new Array<Distretto>();
   aziende_sanitarie = new Array<AziendaSanitaria>();

   strutture = new Array<Struttura>();
   servizi_strutture = new Array<ServizioStruttura>();
   orari_strutture = new Array<OrarioStruttura>();
   tipologie_struttura = new Array<TipologiaStruttura>();
   tipi_serv_strut = new Array<TipoServizioStruttura>();

    _comuni_filtered: Comune[];

    _provincia_corrente_id: number;

    _comune_corrente_id: number;

    _consultori: Struttura[];
    _punti_nascita: Struttura[];
    _ospedali_pediatrici: Struttura[];

    constructor(private modalService: NgbModal, private hmService: HappyMammaService) { }

    async ngOnInit() {

        this.comuni = await this.hmService.comuniToscanaAllPromise();
        this.province_toscane = await this.hmService.provinceToscanaAllPromise();

        this.distretti = await this.hmService.distrettiWithMacrozonaPromise();
        this.aziende_sanitarie = await this.hmService.aziendeAllPromise();

        this.comuni = await this.hmService.comuniAllPromise();

        this.strutture = await this.hmService.struttureAllPromise();

        // this.hmService.getServiziStrutture().subscribe(servizi_strutture => { this.servizi_strutture = servizi_strutture })
        // this.servizi_strutture = await this.hmService.serviziStruttureAllPromise();

        // this.hmService.getOrariStrutture().subscribe(orari_strutture => { this.orari_strutture = orari_strutture })
        // this.orari_strutture = await this.hmService.oraritruttureAllPromise();

        this.tipi_serv_strut = await this.hmService.tipoServizioStrutturaAllPromise();
        const profilo = await this.hmService.getCurrentUserProfile();

        const comuneId = profilo.utente.comune_domicilio ? profilo.utente.comune_domicilio : profilo.utente.comune_residenza;
        const comune = _.find(this.comuni, { id: comuneId });

        this.provincia_corrente_id = comune.provincia;
        this.comune_corrente_id = comune.id;
    }

    set provincia_corrente_id(p: number) {
        this._provincia_corrente_id = p;
        this.filterComuni();
    }

    get provincia_corrente_id(): number {
        return this._provincia_corrente_id;
    }

    updateContent() {
        this.getConsultori();
        this.getPuntiNascita();
        this.getOspedalePediatrico();
    }

    @Input() set comune_corrente_id(c: number) {
        this._comune_corrente_id = +c;
        if (!this.provincia_corrente_id) {
            const comune = _.find(this.comuni, { id: this.comune_corrente_id });
            // console.log(comune)
            if (comune) this.provincia_corrente_id = comune.provincia;
        }
        // console.log(this._comune_corrente_id)
        this.updateContent();
    }

    get comune_corrente_id(): number {
        return this._comune_corrente_id;
    }

    getPuntiNascita() {
        if (!this.strutture) {
            return;
        }
        const strutture_abbinate: Struttura[] = [];
        for (const s of this.strutture) {
            let ca: number[];
            ca = s.comuni_abbinati;
            if (_.find(ca, this.comune_corrente_id)) {
                strutture_abbinate.push(s);
            }
        }
        let comune: Comune;
        comune = _.find(this.comuni, { id: this.comune_corrente_id });
        if (comune && comune.distretto) {
            let distretto: Distretto;
            distretto = _.find(this.distretti, { id: comune.distretto });
            if (distretto && distretto.macrozona) {
                const distretti_macrozona = _.filter(this.distretti, { macrozona: distretto.macrozona });
                for (const d of distretti_macrozona) {
                    const strutts = _.filter(this.strutture, { distretto: d.id, tipologia_struttura: 1 });
                    for (const struttura of strutts) {
                        const azienda = _.filter(this.aziende_sanitarie, { id: struttura.azienda_sanitaria })[0];
                        if (!azienda.universitaria) {
                            strutture_abbinate.push(struttura);
                        }
                    }
                }
            }
            if (distretto && distretto.area_vasta) {
                const aziende_universitarie = _.filter(this.aziende_sanitarie, { area_vasta: distretto.area_vasta, universitaria: true });
                for (const au of aziende_universitarie) {
                    const strutts = _.filter(this.strutture, { azienda_sanitaria: au.id, tipologia_struttura: 1 });
                    for (const struttura of strutts) {
                        strutture_abbinate.push(struttura);
                    }
                }
            }
        }
        this.punti_nascita = strutture_abbinate;
    }

    getConsultori() {
        if (!this.strutture) {
            return;
        }

        const strutture_abbinate: Struttura[] = [];
        for (const s of this.strutture) {
            let ca: number[];
            ca = s.comuni_abbinati;
            if (_.find(ca, this.comune_corrente_id)) {
                strutture_abbinate.push(s);
            }
        }
        const comune = _.find(this.comuni, { id: this.comune_corrente_id });

        if (comune) {
            for (const struttura of this.strutture) {
                if (struttura.tipologia_struttura == 2 && struttura.comuni_abbinati.includes(comune.id))
                    strutture_abbinate.push(struttura);
            }
        }

        this.consultori = strutture_abbinate;
    }

    getOspedalePediatrico() {
        this.ospedali_pediatrici = _.filter(this.strutture, { tipologia_struttura: 3 });
    }

    filterComuni() {
        this.comuni_filtered = _.filter(this.comuni, { provincia: +this.provincia_corrente_id });
        if (this.comuni_filtered.length > 0)
            this.comune_corrente_id = this.comuni_filtered[0].id;
    }

    set comuni_filtered(cf: Comune[]) {
        this._comuni_filtered = cf;
    }
    get comuni_filtered(): Comune[] {
        return this._comuni_filtered;
    }

    set consultori(c: Struttura[]) {
        this._consultori = c;
        // console.log(this._consultori)
    }
    get consultori(): Struttura[] {
        return this._consultori;
    }

    set punti_nascita(c: Struttura[]) {
        this._punti_nascita = c;
    }
    get punti_nascita(): Struttura[] {
        return this._punti_nascita;
    }

    set ospedali_pediatrici(c: Struttura[]) {
        this._ospedali_pediatrici = c;
        // console.log(this._ospedali_pediatrici)
    }
    get ospedali_pediatrici(): Struttura[] {
        return this._ospedali_pediatrici;
    }

    openDettaglioStruttura(s: Struttura) {
        const modal = this.modalService.open(StrutturaDetailComponent, { size: 'lg' });
        modal.componentInstance.struttura = s;

        // modal.componentInstance.servizi_strutture = this.servizi_strutture;
        // modal.componentInstance.tipi_serv_strut = this.tipi_serv_strut;
        // modal.componentInstance.orari_strutture = this.orari_strutture;
        // // console.log(this.servizi_strutture)
    }

}
